export function getItem(key) {
  // Get an item from session storage

  const val = window.sessionStorage.getItem(key);
  return JSON.parse(val);
}

export function setItem(key, value) {
  // Save an item into session storage

  window.sessionStorage.setItem(key, JSON.stringify(value));
}

export function removeItem(key) {
  // Remove an item from session storage

  window.sessionStorage.removeItem(key);
}
